export const HEAD_CELLS = [
  {
    id: 'id',
    label: 'ID события'
  },
  {
    id: 'trigger',
    label: 'Триггер'
  },
  {
    id: 'date_start',
    label: 'Дата старта'
  },
  {
    id: 'date_end',
    label: 'Дата окончания'
  },
  {
    id: 'company', // TODO add company
    label: 'Название кампании'
  },
  {
    id: 'service',
    label: 'Название акции'
  },
  {
    id: 'package',
    label: 'Пакет'
  },
  {
    id: 'status',
    label: 'Статус'
  },
  {
    id: '',
    label: '',
    hideSortIcon: true
  }
];

export const MAILING_HEAD_CELLS = [
  {
    id: 'mailing_type',
    label: 'Тип рассылки'
  },
  {
    id: 'mailing_trigger_id',
    label: 'Триггер отправки'
  },
  {
    id: 'mailing_template_id',
    label: 'Шаблон рассылки'
  },
  {
    id: 'mailing_content',
    label: 'Текст рассылки',
    hideSortIcon: true
  },
  {
    id: 'remove',
    label: '',
    hideSortIcon: true
  }
];

export const SUBSCRIBERS_HEAD_CELLS = [
  {
    id: 'created_at',
    label: 'Дата загрузки'
  },
  {
    id: 'line_amount',
    label: 'Количество абонентов'
  },
  {
    id: 'file_name',
    label: 'Файл'
  },
  {
    id: 'download',
    label: '',
    hideSortIcon: true
  }
];

export const PACKAGES_HEAD_CELLS = [
  {
    id: 'id',
    label: 'ID'
  },
  {
    id: 'name',
    label: 'Наименование пакета'
  },
  {
    id: 'code',
    label: 'код',
    hideSortIcon: true
  },
  {
    id: 'image',
    label: 'Превью',
    hideSortIcon: true
  },
  {
    id: 'status',
    label: 'Статус',
    hideSortIcon: true
  },
  {
    id: '',
    label: '',
    hideSortIcon: true
  }
];
